import React, { useEffect, useRef, useState } from 'react'

// redux
import { connect } from 'react-redux'

// react bootstrap
import { Image, Spinner } from 'react-bootstrap';

// icons : feather
import FeatherIcon from 'feather-icons-react';

// loading
import SkeletonLoading from './Logo__loadingSkeleton';

// APIs
import { addLogoApi } from 'utlis/Apis/Notifications_API';

// react toastify
import { toast } from 'react-toastify';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,

    LOGO_ADDED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

function Logo(props) {
    // props
    const {
        loading,

        notificationsData,

        commonToken
    } = props

    // refs
    const addImgLabelRef = useRef(null)
    const addImgInputRef = useRef(null)

    // states
    const [selectedImage, setSelectedImage] = useState(null)
    const [btnLoading, setBtnLoading] = useState(false)
    const [btnDisabled, setBtnDisabled] = useState(false)

    // setting default image
    useEffect(() => {
        if (notificationsData?.email_logo) {
            setSelectedImage(notificationsData.email_logo) // setting default logo if exists
        }
    }, [notificationsData])

    const saveLogo = file => {
        if (file) {
            // btn loading
            setBtnLoading(true)
            setBtnDisabled(true)

            // adding logo
            addLogoApi(commonToken, file).then(res => {
                // btn loading
                setBtnLoading(false)
                setBtnDisabled(false)

                const resData = res.data

                console.log("resData ", resData);

                // if request succesfull
                if (resData && resData.success) {

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(LOGO_ADDED_SUCCESSFULLY, {
                        autoClose: 2500
                    })
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} addLogoApi `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // btn loading
                        setBtnLoading(false)
                        setBtnDisabled(false)
                    }
                })
            })
        }
    }

    // add image change
    const handleAddLogoChange = ev => {
        let file = ev.target.files[0];

        if (file) {
            // initializing FileReader
            let reader = new FileReader();

            // reading data from the file
            reader.readAsDataURL(file);

            // on load
            reader.onload = function () {
                setSelectedImage(reader.result) // setting selected image

                saveLogo(file) // saving the logo api
            };
            // on error
            reader.onerror = function () {
                console.log("error while getting file info ", reader.error);
            };
        }

    }

    // delete image change
    // const handleDeleteLogo = ev => {
    //     ev.preventDefault()

    //     setSelectedImage(null) // temprory removing the image only
    // }

    return (
        <React.Fragment>
            {
                loading ? ( // if loading is true
                    <div className="page-border-box2 mb-3 mb-md-4 edit-logo-details">
                        <div className="pbb2-inner d-flex">
                            <SkeletonLoading />
                        </div>
                    </div>
                ) : (
                    <div className="page-border-box2 mb-3 mb-md-4 edit-logo-details">
                        <div className="pbb2-inner d-flex">
                            {/* logo */}
                            <div className="logo-sec">
                                {/* HIDDEN INPUT TO SELECT LOGO */}
                                <label className="d-none" ref={addImgLabelRef}>
                                    <input
                                        type="file"
                                        accept=".png, .jpg, .jpeg"
                                        hidden
                                        ref={addImgInputRef}
                                        onChange={handleAddLogoChange}
                                    />
                                </label>

                                {
                                    selectedImage ? ( // if image exist then show image
                                        <div className="img d-flex align-items-center justify-content-center">
                                            <Image src={selectedImage} fluid className="img-img-fluid-height" />
                                        </div>
                                    ) : (
                                        <label className="add-img cursor-pointer" onClick={ev => {
                                            ev.preventDefault()

                                            addImgLabelRef.current.click()
                                        }}>
                                            <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                                {/* box */}
                                                <div className="icon-box d-flex align-items-center justify-content-center">
                                                    <FeatherIcon
                                                        icon="plus"
                                                        size="20"
                                                        className="icon st-text-primary position-relative" />
                                                </div>
                                                {/* text */}
                                                <p className="st-fs-13 st-fw-600 mt-2 st-text-primary">Upload Image</p>
                                            </span>
                                        </label>
                                    )
                                }
                            </div>

                            {/* text sec */}
                            <div className="text-sec media-body ps-3">
                                <div className="app-header-wrapper heading-sm mb-3">
                                    {/* header */}
                                    <p className="app-heading st-fw-600 text-capitalize mb-2">Logo</p>
                                    <p className="app-desc st-fs-14">
                                        This logo will be used in all customer notifications.
                                    </p>
                                </div>

                                <div className="btns d-flex align-items-center mb-2">
                                    <button className={`st-btn st-btn-sm me-2 ${btnDisabled ? "disabled" : ""}`}
                                        onClick={ev => {
                                            ev.preventDefault()

                                            addImgLabelRef.current.click() // triggering click on the file input to select image
                                        }}
                                        disabled={btnDisabled}>
                                        <span>
                                            {
                                                btnLoading ? (
                                                    <Spinner size="sm" animation="border" />
                                                ) : (
                                                    <>
                                                        {selectedImage ? "Change Logo" : "Upload Logo"}
                                                    </>
                                                )
                                            }
                                        </span>
                                    </button>

                                    {
                                        /* delete btn */
                                        // selectedImage ? (
                                        //     <button
                                        //         className="st-round-btn st-btn-white st-btn-sm d-flex align-items-center justify-content-center"
                                        //         title="Delete Logo"
                                        //         onClick={handleDeleteLogo}>
                                        //         <FeatherIcon
                                        //             icon="trash"
                                        //             size="16"
                                        //             className="" />
                                        //     </button>
                                        // ) : null
                                    }
                                </div>

                                <p className="add-info st-fs-13 text-black-50">
                                    Recommended size: 240×100 px
                                </p>
                            </div>
                        </div>
                    </div>
                )
            }
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        commonToken: state.auth.commonToken
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Logo)